
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
                {{ $t("allowance") }}
            </li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
            </button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="onAddNew">
                <i class="fa fa-plus-circle"></i> {{ $t("new") }}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card no-bor">
                <div class="card-body">
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px">{{ $t("no") }}</th>
                                <th>{{ $t("code") }}</th>
                                <th>{{ $t("name") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td><a href="javascript:void(0)" @click="onEdit(ret)">{{ ret.Code }}</a></td>
                                <td>{{ ret.Name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" :title="$t('allowance')" size="sm" ref="innermodal">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.Code.$error }">
                        <label class="label-control blue">{{$t('code')}}</label>
                        <div>
                            <input type="text" class="form-control form-control-sm" v-model="model.Code" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                        <label class="label-control blue">{{$t('name')}}</label>
                        <div>
                            <input type="text" class="form-control form-control-sm" v-model="model.Name" />
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t("save") }}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
    props: {},
    data: function () {
        return {
            records: [],
            model: {
                Code: '',
                Name: ''
            }
        };
    },
    validations: {
        model: {
            Code: { required },
            Name: { required },
        },
    },
    created: function () {
        this.toList();
    },
    methods: {
        toList: function () {
            let loading = this.$loading.show();
            this.$api().post("allowances").then((res) => {
                if (this.$isValid(res)) {
                    this.records = res.data.Json.Allowances;
                }
            }).finally(function () { loading.hide(); });
        },
        onAddNew: function () {
            this.model = {
                Code: '',
                Name: ''
            };
            this.$v.$reset();
            this.$refs.innermodal.show();
        },
        onSave: function () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let loading = this.$loading.show();
                this.$api().post("allowance", this.model).then((res) => {
                    if (this.$isValid(res)) {
                        this.$refs.innermodal.hide();
                        this.toList();
                    }
                }).finally(function () { loading.hide(); });
            }
        },
        onEdit: function (item) {
            this.model = JSON.parse(JSON.stringify(item));
            this.$refs.innermodal.show();
        },
    },
};
</script>
